import { apiFetch } from './client';
import type { WorkZone } from '$lib/types';

// GET /api/work_zones — the current user's own eligible sites (assigned +
// all_users), the same set punch-in verification checks against. Used by
// the punch-in modal's debug map.
export const workZonesApi = {
  mine: () => apiFetch<WorkZone[]>('/work_zones')
};
